import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../components/layout/footer";
import TopBar from "../components/layout/topbar";

const PublicRoutes = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);

  useEffect(() => {
    console.log("[PublicRoutes] MONTADO");
    return () => console.log("[PublicRoutes] DESMONTADO");
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      <ToastContainer />
      <TopBar />
      <div className="p-4 flex-grow-1 d-flex flex-column" style={{ overflowX: "auto" }}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default PublicRoutes;